if (!customElements.get('vbb-reactive-variant-description')) {
  customElements.define('vbb-reactive-variant-description', class ReactiveVariantDescription extends HTMLElement {
    constructor() {
      super();
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    handleVariantChange() {
      const newVariantDescriptionSelector = `[data-template="description"][data-variant-id="${this.productForm.activeVariantId}"]`;
      const newVariantDescriptionContents = this.productForm?.querySelector(newVariantDescriptionSelector);

      if (newVariantDescriptionContents?.innerHTML != null) {
        this.innerHTML = newVariantDescriptionContents.innerHTML;
      }
    }

    connectedCallback() {
      if (!this.productForm) {
        this.productForm = this.closest('vbb-product-form-reactive');
        this.productForm.addEventListener('variant:changed', this.handleVariantChange);
      }
    }

    disconnectedCallback() {
      if (this.productForm) {
        this.productForm.removeEventListener('variant:changed', this.handleVariantChange);
      }
    }
  });
}
